import error from './error';

export default function validateArray(array, name) {
    !Array.isArray(array) && error(
        `${(name ? `${name} are not` : 'Not')} an array`
    );
} 